export { default } from "../../../design-system/layout/Column";


// WEBPACK FOOTER //
// ./src/_components/Layout/Column/index.jsx